import { render, staticRenderFns } from "./MissingMandatoryStepV2.vue?vue&type=template&id=ec97cfce&scoped=true&"
import script from "./MissingMandatoryStepV2.vue?vue&type=script&lang=ts&"
export * from "./MissingMandatoryStepV2.vue?vue&type=script&lang=ts&"
import style0 from "./MissingMandatoryStepV2.vue?vue&type=style&index=0&id=ec97cfce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec97cfce",
  null
  
)

export default component.exports